import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка пользователей
    async getUsers(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`users?${params.toString()}${sorting}`);
    },
    // Получение пользователя по id
    async getUserById(id) {
      return await this.get(`users/id/${id}`);
    },
    // Получение пользователей по запросу
    async getUsersSearch(data) {
      let params = this.makeSearchParams(data);

      if (data.locationId > 0) {
        params.set("location_id", data.locationId);

        if (data.locationPositionId != null) {
          params.set("position_id", data.locationPositionId);
        }
      }

      return await this.get(`users/search?${params.toString()}`);
    },
    // Создание пользователя
    async postUser(data) {
      return await this.post('users', data);
    },
    // Изменение пользователя
    async putUser(data) {
      return await this.put('users', data);
    },
    // Создание пароля пользователя
    async postUserPassword(data) {
      return await this.post('users/password', data);
    },
    async getUserRewards(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`rewards?${params.toString()}`);
    },
    // Информация пользователя
    async getUserInfo() {
      return await this.get('users/info');
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/users.js